import { render, staticRenderFns } from "./cartridge-batch.vue?vue&type=template&id=6f9ca1bd&"
import script from "./cartridge-batch.vue?vue&type=script&lang=js&"
export * from "./cartridge-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9ca1bd')) {
      api.createRecord('6f9ca1bd', component.options)
    } else {
      api.reload('6f9ca1bd', component.options)
    }
    module.hot.accept("./cartridge-batch.vue?vue&type=template&id=6f9ca1bd&", function () {
      api.rerender('6f9ca1bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/cartridge-batch/cartridge-batch.vue"
export default component.exports